<template>
  <main>
    <Filters />
  </main>
</template>

<script>
import Filters from '@/components/Filters'

export default {
  name: 'Listing',
  components: { Filters }
}
</script>


// WEBPACK FOOTER //
// src/components/Listing.vue